import { useEffect } from "react";

const SITE_NAME = "YK İnşaat Müteahhitlik";
const SITE_URL = process.env.REACT_APP_SITE_URL || "https://ykinsaat.com";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSEO — updates document.title, meta description, canonical and OG tags on route change.
 */
export default function useSEO({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
      setMeta("twitter:description", description);
    }

    setMeta("og:title", fullTitle, "property");
    setMeta("twitter:title", fullTitle);

    const url = `${SITE_URL}${path || (typeof window !== "undefined" ? window.location.pathname : "")}`;
    setMeta("og:url", url, "property");
    setCanonical(url);
  }, [title, description, path]);
}
